/**
 * index.js — Widget Entry Point
 *
 * PURPOSE:
 *   The single file esbuild uses as the bundle entry point.
 *   Waits for DOM ready, then calls initWidget().
 *   This is the ONLY file that runs directly in the browser.
 *
 * EMBED CODE (on winery website):
 *   <script
 *     src="https://widget.concierge.redaugment.com/widget.min.js"
 *     data-tenant="goosecross"
 *     defer
 *   ></script>
 *
 * BUILD OUTPUT:
 *   npm run build → dist/widget.min.js
 *   This single file is uploaded to S3 and served via CDN.
 */

import { initWidget } from './core/init.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWidget);
} else {
  initWidget();
}